import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "cols", "span", "className"],
    _excluded2 = ["children", "cols", "direction", "wrap"],
    _excluded3 = ["children", "cols", "span", "offset"],
    _excluded4 = ["layout"],
    _excluded5 = ["key"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* Original name @uswitch/trustyle.flex-grid */

/* eslint-disable no-magic-numbers */
import * as React from 'react';
import classNames from 'classnames';
import { useThemeUI } from 'theme-ui';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { createElement as _createElement } from "theme-ui";

var getGutterSize = function getGutterSize(theme) {
  var _theme$layout$flexGr;

  return (theme === null || theme === void 0 ? void 0 : theme.layout) && (theme === null || theme === void 0 ? void 0 : (_theme$layout$flexGr = theme.layout['flex-grid'].sizes) === null || _theme$layout$flexGr === void 0 ? void 0 : _theme$layout$flexGr.gutter);
};

var getVerticalGutterSize = function getVerticalGutterSize(theme) {
  var _theme$layout$flexGr2;

  return (theme === null || theme === void 0 ? void 0 : theme.layout) && (theme === null || theme === void 0 ? void 0 : (_theme$layout$flexGr2 = theme.layout['flex-grid'].sizes) === null || _theme$layout$flexGr2 === void 0 ? void 0 : _theme$layout$flexGr2.verticalGutter);
};

var getContainerSize = function getContainerSize(theme) {
  var _theme$layout$flexGr3, _theme$layout$flexGr4;

  return (theme === null || theme === void 0 ? void 0 : theme.layout) && (theme === null || theme === void 0 ? void 0 : (_theme$layout$flexGr3 = theme.layout['flex-grid']) === null || _theme$layout$flexGr3 === void 0 ? void 0 : (_theme$layout$flexGr4 = _theme$layout$flexGr3.container) === null || _theme$layout$flexGr4 === void 0 ? void 0 : _theme$layout$flexGr4.maxWidth) || 1200;
};

export var useContainerSize = function useContainerSize() {
  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  return getContainerSize(theme);
};

var castArray = function castArray(valueOrArray) {
  return [].concat(valueOrArray);
}; // wiiilllllson


var getValueFromSize = function getValueFromSize(theme, size) {
  return typeof size === 'number' ? size : theme.space[size] || 0;
};

var getHalf = function getHalf(value) {
  return value / 2;
}; // if we originally had a value outside of an array return it that way
// otherwise the undefined values will cause incorrect responsivness


var uncastArrayIfSingle = function uncastArrayIfSingle(arr) {
  return arr.length === 1 ? arr[0] : arr;
};

var toPx = function toPx(value) {
  return "".concat(value, "px");
};

var getValueFromBreakpointIndex = function getValueFromBreakpointIndex(arr, index) {
  if (arr[index] !== undefined) return arr[index];
  return arr[arr.length - 1];
};

export var isChildOfContainerContext = /*#__PURE__*/React.createContext();
export var columnSizeContext = /*#__PURE__*/React.createContext();
export var Container = function Container(_ref) {
  var children = _ref.children,
      cols = _ref.cols,
      span = _ref.span,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = classNames('flex-grid-container', className);
  var colsArray = castArray(cols);
  var spanArray = castArray(span);
  return _jsx("div", _objectSpread(_objectSpread({
    sx: {
      mx: 'auto',
      boxSizing: 'border-box',
      px: getGutterSize,
      maxWidth: function maxWidth(theme) {
        return uncastArrayIfSingle(castArray(getContainerSize(theme)).map(function (maxWidth, i) {
          return maxWidth * (colsArray[i] && spanArray[i] ? spanArray[i] / colsArray[i] : 1);
        }));
      },
      variant: 'compounds.container.flex'
    }
  }, props), {}, {
    className: classes,
    children: _jsx(isChildOfContainerContext.Provider, {
      value: true,
      children: children
    })
  }));
};
export var Row = function Row(_ref2) {
  var children = _ref2.children,
      _ref2$cols = _ref2.cols,
      cols = _ref2$cols === void 0 ? 12 : _ref2$cols,
      _ref2$direction = _ref2.direction,
      direction = _ref2$direction === void 0 ? ['column', 'row', 'row'] : _ref2$direction,
      _ref2$wrap = _ref2.wrap,
      wrap = _ref2$wrap === void 0 ? true : _ref2$wrap,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var childrenArray = Array.isArray(children) ? children : [children];
  return _jsx("div", _objectSpread(_objectSpread({
    sx: {
      mx: function mx(theme) {
        return uncastArrayIfSingle(castArray(getGutterSize(theme)).map(function (value) {
          return getValueFromSize(theme, value);
        }).map(getHalf).map(function (gutterValue) {
          return "".concat(gutterValue * -1);
        }).map(toPx));
      },
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap ? 'wrap' : 'nowrap'
    }
  }, props), {}, {
    children: childrenArray.map(function (child, key) {
      return /*#__PURE__*/React.isValidElement(child) ? /*#__PURE__*/React.cloneElement(child, {
        cols: cols,
        key: key
      }) : child;
    })
  }));
};
export var Col = function Col(_ref3) {
  var children = _ref3.children,
      _ref3$cols = _ref3.cols,
      cols = _ref3$cols === void 0 ? 12 : _ref3$cols,
      span = _ref3.span,
      offset = _ref3.offset,
      props = _objectWithoutProperties(_ref3, _excluded3);

  var _useThemeUI2 = useThemeUI(),
      theme = _useThemeUI2.theme;

  if (Array.isArray(span) && !Array.isArray(cols)) {
    var colsNumber = cols;
    cols = [];

    for (var i = 0; i < span.length; i++) {
      cols.push(colsNumber);
    }
  }

  var columnValues = castArray(cols).map(function (colValue, index) {
    var gutterValue = toPx(getValueFromBreakpointIndex(castArray(getGutterSize(theme)).map(function (value) {
      return getValueFromSize(theme, value);
    }), index));
    var currentSpan = getValueFromBreakpointIndex(castArray(span), index);
    return {
      currentSpan: currentSpan,
      colValue: colValue,
      gutterValue: gutterValue
    };
  });
  var width = uncastArrayIfSingle(columnValues.map(function (_ref4) {
    var currentSpan = _ref4.currentSpan,
        colValue = _ref4.colValue,
        gutterValue = _ref4.gutterValue;
    return "calc(".concat(currentSpan / colValue * 100, "% - ").concat(gutterValue, ")");
  }));
  return _jsx(columnSizeContext.Provider, {
    value: columnValues,
    children: _jsx("div", _objectSpread(_objectSpread({
      sx: _objectSpread(_objectSpread({
        boxSizing: 'border-box',
        mr: function mr(theme) {
          return uncastArrayIfSingle(castArray(getGutterSize(theme)).map(function (value) {
            return getValueFromSize(theme, value);
          }).map(getHalf).map(toPx));
        },
        mb: getVerticalGutterSize,
        flexGrow: span ? 0 : 1,
        flexShrink: 0,
        flexBasis: "auto"
      }, span ? {
        width: width
      } : {}), offset ? {
        ml: function ml(theme) {
          return uncastArrayIfSingle(castArray(cols).map(function (colValue, index) {
            var gutterValue = getValueFromBreakpointIndex(castArray(getGutterSize(theme)).map(function (value) {
              return getValueFromSize(theme, value);
            }), index);
            var offsetValue = getValueFromBreakpointIndex(castArray(offset).map(function (value) {
              return getValueFromSize(theme, value);
            }), index);
            return "calc(".concat(offsetValue / colValue * 100, "% + ").concat(gutterValue / 2, "px)");
          }));
        }
      } : {
        ml: function ml(theme) {
          return uncastArrayIfSingle(castArray(getGutterSize(theme)).map(function (value) {
            return getValueFromSize(theme, value);
          }).map(getHalf).map(toPx));
        }
      })
    }, props), {}, {
      children: children
    }))
  });
};
export var GridFromJson = function GridFromJson(_ref5) {
  var json = _ref5.json,
      childrenArray = _ref5.childrenArray;
  var flatLayout = json.reduce(function (cells, _ref6) {
    var layout = _ref6.layout;
    return cells.concat(layout);
  }, []);
  var usedKeys = flatLayout.map(function (_ref7) {
    var key = _ref7.key;
    return key;
  });
  var autoKey = 0; // In the future, string key could be support for contentful block ID

  var getChildFromKey = function getChildFromKey(key) {
    // If no key, search for the next key that isn't already used
    if (typeof key === 'undefined') {
      while (usedKeys.includes(autoKey)) {
        autoKey++;
      }

      usedKeys.push(autoKey);
      key = autoKey;
    }

    if (key === '*') {
      throw new Error('Use getWildcardChildren() for this');
    } // We need to pass an ID back as if the key is generated it'll be undefined
    // in the JSX


    return {
      id: key,
      component: childrenArray[key]
    };
  };

  var getWildcardChildren = function getWildcardChildren() {
    var wildcardCount = childrenArray.length - flatLayout.length + 1;
    var wildCardChildren = [];

    for (var i = 0; i < wildcardCount; i++) {
      wildCardChildren.push(getChildFromKey());
    }

    return wildCardChildren;
  };

  return _jsx(React.Fragment, {
    children: json.map(function (_ref8, i) {
      var layout = _ref8.layout,
          rowProps = _objectWithoutProperties(_ref8, _excluded4);

      return _createElement(Row, _objectSpread(_objectSpread({}, rowProps), {}, {
        key: i
      }), layout.map(function (_ref9) {
        var key = _ref9.key,
            colProps = _objectWithoutProperties(_ref9, _excluded5);

        if (key === '*') {
          return getWildcardChildren().map(function (_ref10) {
            var id = _ref10.id,
                component = _ref10.component;
            return _createElement(Col, _objectSpread(_objectSpread({}, colProps), {}, {
              key: id,
              className: "json-grid-col"
            }), component);
          });
        }

        var _getChildFromKey = getChildFromKey(key),
            id = _getChildFromKey.id,
            component = _getChildFromKey.component;

        return _createElement(Col, _objectSpread(_objectSpread({}, colProps), {}, {
          key: id,
          className: "json-grid-col"
        }), component);
      }));
    })
  });
};